import React from 'react';
import { COMPLETED, FAILED, RUNNING, Wrapper } from './styled';
import { get } from 'lodash';

const StatusCell = ({ rowInfo }) => {
  const data = get(rowInfo, 'original', {});
  const running = get(data, 'running', false);
  const successful = get(data, 'successful', false);

  const getStatus = () => {
    if (running) return RUNNING;
    if (successful) return COMPLETED;
    return FAILED;
  };

  return <Wrapper title={ getStatus() }status={ getStatus() }>{getStatus()}</Wrapper>;
};

export default StatusCell;
